import {LegalDocument} from '../../dal';

export class LegalEvents {
    public static readonly documentsRequested = 'legalDocumentsRequested';
    public static readonly documentsLoaded = 'legalDocumentsLoaded';
}

export interface LegalPageDocumentsLoadedEvent {
    readonly documents: LegalDocument[];
}
